module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074f3_banner_800x600.c818e4d0.png";